/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import {getLogArr} from './constant'

export enum PageTypeEnum {
  junior = 1,
  high,
}
export enum process_status {
  未达到 = 0,
  未领取,
  已领取,
}
export enum card_status {
  未刮 = 0,
  开刮,
  刮完,
}

// 总体刮卡信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41433449
export const scratch_card_info = createAsyncThunk(
  'luckyHiya_scratch_card_info',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'is_new'
          | 'times1'
          | 'times2'
          | 'cards1'
          | 'cards2'
          | 'coins'
          | 'process1_status1'
          | 'process1_status2'
          | 'process2_status1'
          | 'process2_status2'
          | 'list'
          | 'highest_reward1'
          | 'highest_reward2'
        >
      >
    >(
      '/live/activity/scratch_card_info',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 刮卡 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41433514
export const scratch_card_scratch = createAsyncThunk(
  'luckyHiya_scratch_card_scratch',
  async (arg: {type: PageTypeEnum; index: number}, store: any) => {
    const {type, index} = arg
    const resp = await http.post<HiyaRes<{is_reward: boolean; coin: number}>>(
      '/live/activity/scratch_card_scratch',
      {
        type,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// 累计次数领奖 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41433512
export const scratch_card_receive = createAsyncThunk(
  'luckyHiya_scratch_card_receive',
  async (arg: {type: PageTypeEnum; process: 1 | 2}, store: any) => {
    const resp = await http.post<HiyaRes<{status: number}>>(
      '/live/activity/scratch_card_receive',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 获奖记录 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41433441
export const scratch_card_record = createAsyncThunk(
  'luckyHiya_scratch_card_record',
  async (arg, store: any) => {
    // 返回的list其实是 record_list
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'list'>>>(
      '/live/activity/scratch_card_record',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 购买卡 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41433454
export const scratch_card_buy = createAsyncThunk(
  'luckyHiya_scratch_card_buy',
  async (arg: {type: PageTypeEnum; num: number}, store: any) => {
    // 0 购买成功 1 金币不足
    const resp = await http.post<HiyaRes<{status: 0 | 1}>>(
      '/live/activity/scratch_card_buy',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export interface member_info {
  avatar: string
  name: string
  coin: number
}
export interface record_info {
  time: string
  type: PageTypeEnum
  coin: number
}
interface res_crads_type {
  img: 'hiya' | 'red' | 'yellow' | 'blue' | 'green'
  status: card_status
  resLogs?: Array<any>
  coin?: number
  // isal:false
}
interface ProcessInfo {
  // 节点礼物信息
  pic: string // 礼物图
  name: string // 礼物名称
  times: number // 礼物获得需要的次数
}
interface InitialStateType {
  pageType: PageTypeEnum
  is_new?: boolean
  times1?: number
  times2?: number
  cards1?: number
  cards2?: number
  remainCards1?: number
  remainCards2?: number
  coins?: number
  process1_status1?: process_status
  card1_process1?: ProcessInfo
  process1_status2?: process_status
  card1_process2?: ProcessInfo
  process2_status1?: process_status
  card2_process1?: ProcessInfo
  process2_status2?: process_status
  card2_process2?: ProcessInfo
  highest_reward1?: number
  highest_reward2?: number
  list?: Array<member_info>
  record_list?: Array<record_info>
  res_crads: Array<res_crads_type>
  showRes: boolean
}

const initialState: InitialStateType = {
  pageType: PageTypeEnum.junior,
  res_crads: [],
  showRes: false,
}

export const luckyHiyaSlice = createSlice({
  name: 'luckyHiya',
  initialState,
  reducers: {
    changePageType: (state, action: PayloadAction<PageTypeEnum>) => {
      Object.assign(state, {
        pageType: action.payload,
      })
    },
    getResCards: (state, action: PayloadAction<Array<res_crads_type>>) => {
      Object.assign(state, {
        res_crads: action.payload,
      })
    },
    changeStatus: (
      state,
      action: PayloadAction<{index: number; status: card_status}>
    ) => {
      const {index, status} = action.payload
      const {res_crads} = state
      res_crads[index].status = status
      Object.assign(state, {
        res_crads,
      })
    },
    setShowRes: (state, action) => {
      Object.assign(state, {
        showRes: true,
      })
    },
    resetShowRes: (state, action) => {
      Object.assign(state, {
        showRes: false,
      })
    },

    changeRemain: (
      state,
      action: PayloadAction<{pageTabIndex: PageTypeEnum; coin: number}>
    ) => {
      const {pageTabIndex, coin} = action.payload
      const {remainCards1, remainCards2, coins} = state
      const temp: any = {}
      temp.coins = coins + (coin || 0)
      if (pageTabIndex === PageTypeEnum.junior) {
        temp.remainCards1 = remainCards1 - 1 || 0
      } else {
        temp.remainCards2 = remainCards2 - 1 || 0
      }
      Object.assign(state, temp)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(scratch_card_info.fulfilled, (state, action) => {
      const {cards1: remainCards1, cards2: remainCards2} = action.payload
      const {pageType, res_crads} = state

      if (
        {
          [PageTypeEnum.junior]: remainCards1,
          [PageTypeEnum.high]: remainCards2,
        }[pageType] <= 0
      ) {
        res_crads.splice(0, res_crads.length)
      }
      Object.assign(state, action.payload, {
        remainCards1,
        remainCards2,
        res_crads,
      })
    })

    builder.addCase(scratch_card_scratch.fulfilled, (state, action) => {
      const {index, type: pageTabIndex} = action.meta.arg
      const {is_reward, coin} = action.payload
      const {res_crads, coins, remainCards1, remainCards2} = state
      res_crads[index].coin = coin || 0
      res_crads[index].resLogs = getLogArr(is_reward)
      const temp: any = {}
      if (pageTabIndex === PageTypeEnum.junior) {
        temp.remainCards1 = remainCards1 - 1 || 0
      } else {
        temp.remainCards2 = remainCards2 - 1 || 0
      }
      // setStorageKeys(
      //   pageTabIndex,
      //   getStorageKeys(pageTabIndex).split(',').splice(index, 1).join(',')
      // )

      Object.assign(state, temp, {coins: coins + (coin || 0), res_crads})
    })
  },
})
export default luckyHiyaSlice.reducer
export const luckyHiyaActions = luckyHiyaSlice.actions
